/**
 * Helpers puros de apresentação do dashboard operacional (Home admin).
 * Compartilhados entre desktop (home.js) e mobile (MobileHome.js).
 */

export const ACTIVE_QUEUE_STATUSES = ["QUEUE", "GRADING", "GRADED"];
export const INCOMING_STATUSES = ["APPROVED", "HOLD", "SENT"];
// EM ANALISE fica fora da fila de produção — seção secundária no dashboard.
export const ANALYZING_STATUSES = ["ANALYZING"];

export const URGENCY_META = {
    overdue: { label: "Atrasado", classes: "bg-red-600 text-white" },
    critical: { label: "Crítico", classes: "bg-orange-500 text-black" },
    high: { label: "Alta", classes: "bg-primary text-black" },
    medium: { label: "Média", classes: "bg-yellow-200 text-black" },
    normal: { label: "No prazo", classes: "bg-mgs-elevated text-laranjinha border border-primary/40" },
    none: { label: "Sem prazo", classes: "bg-mgs-elevated text-laranjinha/60 border border-primary/20" },
};

export const getUrgencyMeta = (urgency) => URGENCY_META[urgency] ?? URGENCY_META.none;

export const formatDate = (value) => {
    if (!value) return "—";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "—";
    return date.toLocaleDateString("pt-BR");
};

export const describeDaysLeft = (daysLeft) => {
    if (daysLeft === null || daysLeft === undefined) return "sem prazo";
    if (daysLeft < 0) {
        const late = Math.abs(daysLeft);
        return late === 1 ? "1 dia de atraso" : `${late} dias de atraso`;
    }
    if (daysLeft === 0) return "vence hoje";
    return daysLeft === 1 ? "vence em 1 dia" : `vence em ${daysLeft} dias`;
};

export const formatItems = (bucket) => {
    const items = bucket?.items ?? 0;
    const orders = bucket?.orders ?? 0;
    return {
        items,
        orders,
        ordersLabel: orders === 1 ? "1 pedido" : `${orders} pedidos`,
    };
};
